<template>
<div class="popup" v-show="syncOptionShow" v-cloak>
    <div class="content" id="syncOptions">
        <div class="title">
            {{$t('language.common.options')}}
            <div class="icon white-close dialog-close" @click="optionClose()"></div>
        </div>
        <div class="transfer-options-body">
            <div class="transfer-options-cont">
                <el-tabs v-model=activeName>
                    <el-tab-pane :label="$t('language.popup.syncModes')" name="first">
                        <tab1 ref="tab1"></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.popup.email')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label" name="third" class="transfer-vip">
                            <span>{{$t('language.popup.filter')}}</span>
                            <div class="icon-util vip filter-position"></div>
                        </span>
                        <tab3 ref="tab3"></tab3>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="transfer-options-footer">
                <button style="float:right;" @click="optionSubmit()">{{$t('language.common.save')}}</button>
                <button class="white-button" style="float:right;margin-right: 10px;" @click="optionClose()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/transfer_options.css'
import tab1 from "@/components/common/tabs/tabs_transfer_options/tab_sync";
import tab2 from "@/components/common/tabs/tabs_transfer_options/tab_email";
import tab3 from "@/components/common/tabs/tabs_transfer_options/tab_filter";
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    components: {
        tab1,
        tab2,
        tab3
    },
    data: function () {
        return {
            syncOptionShow: false,
            activeName: "first",
            tabs: [{
                name: this.$t('language.popup.syncModes')
            }, {
                name: this.$t('language.popup.email')
            }, {
                name: this.$t('language.popup.filter')
            }],
            indexCurrent: 0,
            tabBarClass: '',
            options: {
                way: 10,
                isChar: 1,
            },
            oldOptions: {
                 way: 10,
                isChar: 1,
            },
            downOpen: true, //用于标记是否是打开的是页面底部的option
            oldRealTimeMode:true
           
        };
    },
    methods: {
        optionSubmit() {
            let payWayArr = [11, 12, 13, 14, 15, 16];
            let that = this;
            //保存用户所选择的数据
            delete this.options.matched;
            delete this.options.pattern;
            let user = commonUtils.getUserToLocal();
            if (payWayArr.includes(this.options.way)) {
                //付费功能弹窗提醒
                if (!user.vip) {
                    var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_modes');
                    upgradeNewDialog.curItem = 'modes';
                    upgradeNewDialog.isShow = true;
                    return false;
                }
            }
            //用户保存filter数据
            //当用户勾选了邮箱但没有填邮箱
            if (!this.$refs.tab2.email && this.$refs.tab2.sendShow) {
                this.indexCurrent = 1;
                this.activeName = 'second';
                this.$refs.tab2.shakeBox = "email-shake";
                setTimeout(() => {
                    this.$refs.tab2.shakeBox = "box-shakeOrigin";
                }, 200);
            } else {
                if (this.$refs.tab2.email) {
                    if (!commonstate.emailpattern.test(this.$refs.tab2.email)) {
                        this.activeName = 'second';
                        this.$toast({
                            text: this.$t('language.login.enterCorrectEmai'),
                            type: 'fail',
                            idValue: "syncOptions"
                        });
                        return false;
                    }
                    this.options.email = this.$refs.tab2.email;
                } else {
                    delete this.options.email;
                }
                if (this.$refs.tab3.items.length) {
                    //付费功能弹窗提醒
                    if (!user.vip) {
                        var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_filter');
                        upgradeNewDialog.curItem = 'filter';
                        upgradeNewDialog.isShow = true;
                        return false;
                    }
                    if (this.$refs.tab3.radioCurrent == 0) {
                        this.options.pattern = 'exclude';
                    } else if (this.$refs.tab3.radioCurrent == 1) {
                        this.options.pattern = 'include';
                    }
                    for (let i = 0; i < this.$refs.tab3.items.length; i++) {
                        if (this.options.matched) {
                            this.options.matched = this.options.matched + '*' + this.$refs.tab3.items[i] + '|';
                        } else {
                            this.options.matched = '*' + this.$refs.tab3.items[i] + '|';
                        }
                    }
                    let index = this.options.matched.lastIndexOf('|');
                    this.options.matched = this.options.matched.substring(0, index);
                }
                this.syncOptionShow = false;
                let selectOneNowValue = this.$refs.tab1.$refs.selectOne.currentValue;
                let selectTwoNowValue = this.$refs.tab1.$refs.selectTwo.currentValue;
                this.$refs.tab1.onChangeOptionOne(selectOneNowValue);
                this.$refs.tab1.oldSelectOneValue = selectOneNowValue;
                if (selectOneNowValue != this.$t('language.popup.twowaySync')) {
                    this.$refs.tab1.onChangeOptionTwo(selectTwoNowValue);
                    this.$refs.tab1.oldSelectTwoValue = selectTwoNowValue;
                    this.$parent.twoWayShow = false;
                }else{
                     this.$parent.twoWayShow = true;
                }
                this.$refs.tab1.oldIsActive = this.$refs.tab1.isActive;
                 //控制上个界面的默认值
                 if(this.$refs.tab1.realTimeMode){
                      this.$parent.realTimeMode=true;
                      this.$parent.checkedSchedule=false;
                      if(this.$parent.mulitDrives.length>1){
                        this.$parent.mulitDrives=[];
                        this.$store.state.syncArr=[];  
                      }
                 }else{
                      this.$parent.realTimeMode=false;
                      this.$parent.$refs.syncAimsDialog.realTimeMode=false;
                      this.$parent.scheduleShow=true;
                 }
                 this.$parent.pOptions = Object.assign({}, this.options);
                 this.$parent.optionOpen=true;
            }
             if(this.options.way==20 && this.$parent.mulitDrives.length>1){
                        this.$parent.mulitDrives=[];
                        this.$store.state.syncArr=[];  
                }
            this.oldOptions = Object.assign({}, this.options);
            this.oldRealTimeMode =  this.$refs.tab1.realTimeMode;
            if( this.$refs.tab1.realTimeMode){
                this.$parent.realTimeShow=true;
                this.$parent.scheduleShow=false;
                 this.$parent.checkedSchedule=false;
            }
        },
        optionClose() {
            let that = this;
            let suffix;
            //还原当前页面选择的弹窗
            // if (this.oldOptions.way == 10) {
            //     this.$parent.$refs.cloudSelect.currentValue = this.$t("language.popup.onewaySync");
            // }
            // if (this.oldOptions.way == 20) {
            //     this.$parent.$refs.cloudSelect.currentValue = this.$t('language.popup.twowaySync');
            // }
             if(this.oldRealTimeMode){
                     // this.$parent.$refs.cloudSelect.currentValue = this.$t('language.cloudSync.realTimeSync');
                       this.$parent.realTimeMode=true;
                       this.$parent.realTimeShow=true;
                       this.$parent.scheduleShow=false;
            }else{
                     // this.$parent.$refs.cloudSelect.currentValue = this.$t('language.cloudSync.normalSync');
                      this.$parent.realTimeMode=false;
                      this.$parent.realTimeShow=false;
                      this.$parent.scheduleShow=true;
             }
            //还原用户之前选择的数据
            this.syncOptionShow = false;
            //控制界面tab1显示效果
            let selectOneNowValue = this.$refs.tab1.$refs.selectOne.currentValue;
            let selectTwoNowValue = this.$refs.tab1.$refs.selectTwo.currentValue;
            this.$refs.tab1.onChangeOptionOne(selectOneNowValue);
            this.$refs.tab1.onChangeOptionTwo(selectTwoNowValue);
            if (this.downOpen) {
                this.$refs.tab1.$refs.selectOne.currentValue = this.$refs.tab1.oldSelectOneValue;
                this.$refs.tab1.$refs.selectTwo.currentValue = this.$refs.tab1.oldSelectTwoValue;
                this.$refs.tab1.isActive = this.$refs.tab1.oldIsActive;
            }
            //还原tab2用户之前选择的数据
            if (this.oldOptions.email) {
                this.$refs.tab2.sendShow = true;
                this.$refs.tab2.email = this.oldOptions.email;
            } else {
                this.$refs.tab2.sendShow = false;
                this.$refs.tab2.email = "";
            }
            //还原tab3用户之前选择的数据
            that.$refs.tab3.inputValue = null;
            that.$refs.tab3.items = [];
            that.$refs.tab3.includeArr = [];
            that.$refs.tab3.ignoreArr = [];
            if (this.oldOptions.pattern) {
                let pattern = this.oldOptions.pattern;
                if (pattern == 'exclude') {
                    this.$refs.tab3.radioCurrent = 0;
                } else {
                    this.$refs.tab3.radioCurrent = 1;
                }
                let arr = this.oldOptions.matched.split('*');
                $.each(arr, function (i, item) {
                    if (item && i != arr.length - 1) {
                        suffix = item.substring(0, item.length - 1);
                        that.$refs.tab3.items.push(suffix);
                    }
                    if (i == arr.length - 1) {
                        suffix = item;
                        that.$refs.tab3.items.push(suffix);
                    }
                });
            }
          
        },
        clearAllData() {
             this.oldOptions={};
            this.activeName = 'first';
            this.$refs.tab2.sendShow = false;
            this.$refs.tab2.email = '';
            this.$refs.tab3.items = [];
            this.$refs.tab3.ignoreArr = [];
            this.$refs.tab3.includeArr = [];
            this.$refs.tab1.isActive = true;
             this.$refs.tab1.oldIsActive = true;
            this.options.isChar = 1;
            this.$refs.tab1.oldSelectOneValue=this.$t('language.popup.onewaySync');
            this.$refs.tab1.oldSelectTwoValue=this.$t('language.popup.simpleSync');
            this.$refs.tab1.onChangeOptionOne(this.$t('language.popup.onewaySync'));
            this.$refs.tab1.onChangeOptionTwo(this.$t('language.popup.simpleSync'));
            this.$refs.tab1.$refs.selectOne.currentValue = this.$t('language.popup.onewaySync');
            this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.simpleSync');
            this.$refs.tab1.deleteOptionOne = [];
            this.$refs.tab1.deleteOptionTwo = [];
        }
    }
}
</script>

<style>
.sync-tabs-label {
    margin-right: 40px;
    /*no*/
    float: left;
    font-size: 14px;
    /*no*/
    color: #6f7886;
}

#syncOptions {
    width: 680px;
    /*no*/
    height: 510px;
    /*no*/
}

#syncOptions .transfer-options-body {
    height: 440px;/*no*/
}

#syncOptions #tab-2,
#syncOptions #tab-first,
#syncOptions #tab-second,
#syncOptions #tab-third {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
}

#tab-second {
    margin-left: 0 !important;
}

.is-top {
    margin: 0 !important;
}

#syncOptions .el-tabs__content {
    height: 250px;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    overflow: visible;
}


</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/sync_options_popup.vue